<template>
  <button
    class="floating-back-btn"
    @click="handleBack"
    aria-label="رجوع"
  >
    <span class="icon" aria-hidden="true">
      <!-- سهم أنيق بدون مكتبات خارجية -->
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M15 18l-6-6 6-6"/>
      </svg>
    </span>
    <span class="label">رجوع</span>
  </button>
</template>

<script>
export default {
  name: 'FloatingBackButton',
  methods: {
    handleBack() {
      if (this.$route.name === 'ExamScreen' || this.$route.path.startsWith('/exam')) {
        const confirmed = window.confirm('هل أنت متأكد من الخروج من الامتحان؟ سيتم فقدان التقدم الحالي.');
        if (confirmed) {
          this.$emit('back');
        }
      } else {
        this.$emit('back');
      }
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@500;700&display=swap');

/* متغيرات فاخرة */
:root {
  --btn-bg: rgba(255, 255, 255, 0.12);        /* شفافية واضحة */
  --btn-bg-hover: rgba(255, 255, 255, 0.18);  /* عند المرور */
  --btn-bg-active: rgba(255, 255, 255, 0.22); /* عند الضغط */
  --btn-border: rgba(255, 255, 255, 0.35);
  --btn-shadow: 0 6px 18px rgba(0,0,0,0.35);
  --btn-shadow-hover: 0 8px 22px rgba(0,0,0,0.45);
  --btn-icon: #ffffff;
}

/* زر رجوع دائري فاخر */
.floating-back-btn {
  position: fixed;
  bottom: calc(1rem + 1.2cm);
  left: 1rem;

  width: auto;
  min-width: 3.4rem;
  height: 3.4rem;

  padding: 0 0.9rem;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50px; /* دائري لكن يسمح للكلمة بالظهور */
  border: 1px solid rgba(255, 255, 255, 0.25);

  background: rgba(255, 255, 255, 0.10); /* شفافية واضحة */
  backdrop-filter: blur(12px) saturate(160%);
  -webkit-backdrop-filter: blur(12px) saturate(160%);

  cursor: pointer;
  z-index: 1500;

  box-shadow: 0 6px 18px rgba(0,0,0,0.35);

  transition:
    transform .18s ease,
    background .22s ease,
    box-shadow .22s ease,
    filter .22s ease;
}

/* كلمة رجوع */
.floating-back-btn .label {
  font-family: 'Cairo', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #ff6b6b; /* أحمر هادئ غير مزعج */
  letter-spacing: 0.5px;
  user-select: none;
}

/* عند المرور */
.floating-back-btn:hover {
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.16);
  box-shadow: 0 8px 22px rgba(0,0,0,0.45);
}

/* عند الضغط */
.floating-back-btn:active {
  transform: translateY(1px) scale(0.96);
  background: rgba(255, 255, 255, 0.22);
  filter: brightness(0.96);
}

/* عند التركيز */
.floating-back-btn:focus-visible {
  outline: none;
  box-shadow:
    0 0 0 3px rgba(255, 107, 107, 0.35),
    0 6px 18px rgba(0,0,0,0.35);
}

/* الوضع الداكن */
@media (prefers-color-scheme: dark) {
  :root {
    --btn-bg: rgba(255, 255, 255, 0.10);
    --btn-bg-hover: rgba(255, 255, 255, 0.16);
    --btn-bg-active: rgba(255, 255, 255, 0.20);
    --btn-border: rgba(255,255,255,0.25);
    --btn-icon: #f8fafc;
  }
}

/* تحسين اللمس */
@media (hover: none) {
  .floating-back-btn {
    width: 3.3rem;
    height: 3.3rem;
  }
}
</style>
